// Flat blue for the first half — usage isn't a concern yet — then blue ->
// amber -> red for the second half, so the color only starts moving once
// there's actually something to pay attention to. Shared by the sidebar
// profile avatar and its dropdown's balance card, so both agree on what
// a given usage percentage looks like.
const USAGE_COLOR_STOPS = [
  { at: 0, rgb: [59, 130, 246] },
  { at: 50, rgb: [59, 130, 246] },
  { at: 75, rgb: [245, 158, 11] },
  { at: 100, rgb: [239, 68, 68] },
];

export function usageColor(percent) {
  const clamped = Math.max(0, Math.min(100, percent));
  for (let i = 0; i < USAGE_COLOR_STOPS.length - 1; i++) {
    const lower = USAGE_COLOR_STOPS[i];
    const upper = USAGE_COLOR_STOPS[i + 1];
    if (clamped <= upper.at) {
      const t = (clamped - lower.at) / (upper.at - lower.at);
      const rgb = lower.rgb.map((channel, idx) => Math.round(channel + (upper.rgb[idx] - channel) * t));
      return `rgb(${rgb.join(",")})`;
    }
  }
  const last = USAGE_COLOR_STOPS[USAGE_COLOR_STOPS.length - 1].rgb;
  return `rgb(${last.join(",")})`;
}
